import React from "react";
import { AppDialog, FormActions, FormField } from "../app";
import { Input } from "../ui/input";
import {
  PurchaseOrderFormFields,
  PurchaseOrderInvoiceField,
  SupplierFormFields,
} from "./SupplierFormSections";

function PurchaseOrderSummary({ purchaseOrder, isSpanish, showCurrentInvoice = false }) {
  if (!purchaseOrder) return null;

  return (
    <div className="rounded border border-[#242E42] p-3 text-sm text-[#9CA3AF]">
      <p className="font-medium text-[#F3F4F6]">{purchaseOrder.po_number}</p>
      <p>{purchaseOrder.supplier_name}</p>
      <p className="font-semibold text-[#E2B05E]">
        ${purchaseOrder.total?.toLocaleString()}
      </p>
      {showCurrentInvoice && purchaseOrder.invoice_attachment && (
        <p className="mt-2 truncate">
          {isSpanish ? "Actual" : "Current"}:{" "}
          {purchaseOrder.invoice_attachment.filename}
        </p>
      )}
    </div>
  );
}

export function SupplierDialog({
  open,
  onOpenChange,
  editingSupplier,
  formData,
  setFormData,
  isSpanish,
  onSubmit,
  onCancel,
}) {
  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      size="md"
      title={
        editingSupplier
          ? isSpanish
            ? "Editar Proveedor"
            : "Edit Supplier"
          : isSpanish
            ? "Nuevo Proveedor"
            : "New Supplier"
      }
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <SupplierFormFields
          formData={formData}
          setFormData={setFormData}
          isSpanish={isSpanish}
        />
        <FormActions
          cancelLabel={isSpanish ? "Cancelar" : "Cancel"}
          submitLabel={
            editingSupplier
              ? isSpanish
                ? "Actualizar"
                : "Update"
              : isSpanish
                ? "Crear"
                : "Create"
          }
          onCancel={onCancel}
        />
      </form>
    </AppDialog>
  );
}

export function PurchaseOrderDialog({
  open,
  onOpenChange,
  formData,
  setFormData,
  suppliers,
  invoiceInputRef,
  invoiceFile,
  onInvoiceFileChange,
  onClearInvoiceFile,
  onSelectInvoiceFile,
  formatFileSize,
  isSpanish,
  onSubmit,
  onCancel,
}) {
  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      size="md"
      title={isSpanish ? "Nueva Orden de Compra" : "New Purchase Order"}
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <PurchaseOrderFormFields
          formData={formData}
          setFormData={setFormData}
          suppliers={suppliers}
          isSpanish={isSpanish}
        />
        <PurchaseOrderInvoiceField
          inputRef={invoiceInputRef}
          file={invoiceFile}
          onFileChange={onInvoiceFileChange}
          onClearFile={onClearInvoiceFile}
          onSelectFile={onSelectInvoiceFile}
          formatFileSize={formatFileSize}
          isSpanish={isSpanish}
        />
        <FormActions
          cancelLabel={isSpanish ? "Cancelar" : "Cancel"}
          submitLabel={isSpanish ? "Crear Orden" : "Create Order"}
          onCancel={onCancel}
        />
      </form>
    </AppDialog>
  );
}

export function PurchaseOrderInvoiceDialog({
  open,
  onOpenChange,
  selectedPO,
  invoiceUploadInputRef,
  invoiceFile,
  onInvoiceFileChange,
  onClearInvoiceFile,
  onSelectInvoiceFile,
  formatFileSize,
  isSpanish,
  onSubmit,
  onCancel,
}) {
  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      title={
        selectedPO?.invoice_attachment
          ? isSpanish
            ? "Reemplazar factura"
            : "Replace invoice"
          : isSpanish
            ? "Agregar factura"
            : "Add invoice"
      }
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <PurchaseOrderSummary
          purchaseOrder={selectedPO}
          isSpanish={isSpanish}
          showCurrentInvoice
        />
        <PurchaseOrderInvoiceField
          inputRef={invoiceUploadInputRef}
          file={invoiceFile}
          onFileChange={onInvoiceFileChange}
          onClearFile={onClearInvoiceFile}
          onSelectFile={onSelectInvoiceFile}
          formatFileSize={formatFileSize}
          isSpanish={isSpanish}
          mode="select"
        />
        <FormActions
          cancelLabel={isSpanish ? "Cancelar" : "Cancel"}
          submitLabel={isSpanish ? "Guardar factura" : "Save invoice"}
          onCancel={onCancel}
        />
      </form>
    </AppDialog>
  );
}

export function PurchaseOrderCancelDialog({
  open,
  onOpenChange,
  selectedPO,
  bankTransferNumber,
  setBankTransferNumber,
  isSpanish,
  onSubmit,
  onCancel,
}) {
  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      size="sm"
      title={isSpanish ? "Cancelar orden de compra" : "Cancel purchase order"}
    >
      <form onSubmit={onSubmit} className="space-y-4">
        <FormField
          label={
            isSpanish
              ? "Numero de transferencia o referencia de cheque"
              : "Transfer number or check reference"
          }
          required
        >
          <Input
            value={bankTransferNumber}
            onChange={(event) => setBankTransferNumber(event.target.value)}
            className="valhalla-input"
            required
          />
        </FormField>
        <PurchaseOrderSummary purchaseOrder={selectedPO} isSpanish={isSpanish} />
        <FormActions
          cancelLabel={isSpanish ? "Volver" : "Back"}
          submitLabel={isSpanish ? "Guardar" : "Save"}
          onCancel={onCancel}
        />
      </form>
    </AppDialog>
  );
}
